module.exports = __webpack_public_path__ + "img/confignoti.31fbd4e4.svg";